// extracted by mini-css-extract-plugin
export default {"download-license":"XdfNtP2EioJZBj7BKu_K","license-text":"xfWliqGCvx5WHruxmCqf"};